import { Expose, Transform, Type } from 'class-transformer'

import { Base } from './Base'
import { BarcodedUnit } from './BarcodedUnit'
import { ParcelShipment } from './ParcelShipment'

export class ParcelShipmentBarcodedUnit extends Base {
  @Expose({ name: 'unit' })
  @Transform(({ unit }) => unit?.guid)
  guid: string = ''

  @Type(() => ParcelShipment)
  shipment?: ParcelShipment

  @Type(() => BarcodedUnit)
  unit?: BarcodedUnit
}
